<template>
    <div id="main-container">
        <div class="navbar-container" style="position: fixed; top: 0; left: 0; right: 0; z-index: 999;">
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
                <div class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link"
                            @click.prevent="downloadFile">
                            <font-awesome-icon icon="download" class="text-secondary" />
                        </router-link>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </div>
        <div class="scrollable-container" style="background-color: white;">
            <div class="content">
                <div v-if="url" class="w-100">
                    <img v-if="isImage" class="w-100" style="height: auto; z-index: 99999;" :src="url" />
                    <iframe v-else id="iframe-page" :src="url" class="w-100" frameborder="0"
                        style="height: 90vh; z-index: 99999;">
                    </iframe>
                </div>
                <div v-else class="w-100 p-3 mt-5">
                    <div v-if="!loading"
                        class="d-flex flex-column justify-content-center align-items-center text-center mt-2">
                        <img id="img-card" class="img-card" src="@/assets/images/logo-empty.png" />
                        <div class="d-flex flex-column">
                            <label class="mt-4 mb-1 font-weight-bold">
                                {{ $t('Your URL is not valid!') }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { Browser } from '@capacitor/browser';

export default {
    name: "IframePage",
    components: {
        //
    },
    data() {

        return {
            loading: false,
            url: null,
            file_name: 'file',
            file_format: null,
            known_formats: ['pdf', 'jpg', 'jpeg', 'png', 'gif'],
            isImage: false
        };
    },
    computed: {
        //
    },
    created() {
        this.loading = true;
        let loader = this.$loading.show();
        if (!this.$route.query.data) {
            this.url = null;
            this.loading = false;
            loader.hide();
        } else {
            let decrypted = this.$decryptString(this.$route.query.data, 'encryptKey');
            if (decrypted == null || decrypted.indexOf("{") == -1) {
                this.url = null;
                this.loading = false;
                loader.hide();
                return;
            }

            let data = JSON.parse(decrypted);
            if (!data.url) {
                this.url = null;
                this.loading = false;
                loader.hide();
                return;
            }

            this.url = data.url;
            this.file_name = data.name ?? 'file';

            let hasExtension = this.url.split('/').pop().includes('.');
            if (hasExtension) {
                this.file_format = this.url.split('.').pop().toLowerCase();
            } else {
                this.file_format = null;
            }

            let image_formats = ['jpg', 'jpeg', 'png', 'gif'];
            if (image_formats.includes(this.file_format)) {
                this.isImage = true;
            } else {
                this.isImage = false;
            }

            this.loading = false;
            loader.hide();
        }
    },
    methods: {
        resizePage() {
            if (document.getElementById('main-container')) {
                let deviceWidth = window.matchMedia("(max-width: 1024px)");
                if (deviceWidth.matches) {
                    document.getElementById('main-container').style.height = window.innerHeight + 'px';
                } else {
                    document.getElementById('main-container').style.height = '100vh';
                }

                if (document.getElementsByClassName('navbar-container')[0] && document.getElementsByClassName('scrollable-container')[0]) {
                    let mainContainerHeight = document.getElementById('main-container').offsetHeight;
                    let navbarContainerHeight = document.getElementsByClassName('navbar-container')[0].offsetHeight;

                    document.getElementsByClassName('scrollable-container')[0].style.height = (mainContainerHeight - navbarContainerHeight - 7) + 'px';
                    document.getElementsByClassName('scrollable-container')[0].style.marginTop = navbarContainerHeight + 'px';

                    if (this.transaction && this.transaction.payment_link && document.getElementById('iframe-page')) {
                        document.getElementById('iframe-page').style.height = (mainContainerHeight - navbarContainerHeight - 7) + 'px';
                    }
                }
            }
        },

        goBack() {
            this.navigateBackOrHome();
        },

        async downloadFile() {
            let url = this.url;
            if (url.includes('?view=iframe')) {
                url = url.split('?view=iframe')[0];
            }

            if (this.file_format && this.known_formats.includes(this.file_format)) {
                if (this.$isCapacitor()) {
                    try {
                        await Browser.open({ url });
                    } catch (error) {
                        this.$vueAlert.alert(error, null, 'error');
                    }
                } else {
                    window.open(url, '_blank');
                }
            } else {
                window.open(url, '_blank');
            }
        }
    },
    watch: {
        url: function () {
            //wait for dom to render iframe
            this.$nextTick(function () {
                this.resizePage();
            });
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.resizePage();
        })
    },
    beforeUnmount() {
        window.removeEventListener('resize', () => {
            this.resizePage();
        })
    },
};
</script>